var map = {
	"./adminprofile/edit": [
		2017,
		19
	],
	"./agentprofile/edit": [
		2018,
		22
	],
	"./ai_assistant/edit": [
		2019,
		25
	],
	"./api_key/edit": [
		2020,
		28
	],
	"./canned_answer/edit": [
		2021,
		33
	],
	"./chat_configuration/edit": [
		2022,
		6
	],
	"./client/edit": [
		2023,
		36
	],
	"./destination_restrictor/edit": [
		2024,
		38
	],
	"./disposition/edit": [
		2025,
		41
	],
	"./field/edit": [
		2026,
		44
	],
	"./form/edit": [
		2027,
		47
	],
	"./form_website/edit": [
		2028,
		50
	],
	"./gdpr/edit": [
		2029,
		52
	],
	"./invoice/edit": [
		2030,
		54
	],
	"./invoice_post/edit": [
		2031,
		57
	],
	"./journey/edit": [
		2032,
		60
	],
	"./journey_draft/edit": [
		2033,
		63
	],
	"./journey_variable/edit": [
		2034,
		67
	],
	"./list/edit": [
		2035,
		70
	],
	"./list_file/edit": [
		2036,
		73
	],
	"./mail_account/edit": [
		2037,
		76
	],
	"./operational_hours/edit": [
		2038,
		79
	],
	"./organization/edit": [
		2039,
		82
	],
	"./pause/edit": [
		2040,
		85
	],
	"./phonenumber_monthly_cost/edit": [
		2041,
		88
	],
	"./phonenumber_monthly_cost_parent/edit": [
		2042,
		91
	],
	"./phonenumber_purchase/edit": [
		2043,
		95
	],
	"./phonenumber_setup_cost/edit": [
		2044,
		98
	],
	"./phonenumber_setup_cost_parent/edit": [
		2045,
		101
	],
	"./points_system/edit": [
		2046,
		105
	],
	"./prepaid_credit/edit": [
		2047,
		108
	],
	"./queue/edit": [
		2048,
		111
	],
	"./signature/edit": [
		2049,
		115
	],
	"./skill/edit": [
		2050,
		118
	],
	"./sla_policy/edit": [
		2051,
		121
	],
	"./sound/edit": [
		2052,
		124
	],
	"./stats_alarm/edit": [
		2053,
		127
	],
	"./stats_custom_metric/edit": [
		2054,
		130
	],
	"./stats_report/edit": [
		2055,
		133
	],
	"./stats_widget/edit": [
		2056,
		136
	],
	"./superadmin_profile/edit": [
		2057,
		139
	],
	"./tag/edit": [
		2058,
		142
	],
	"./tariff/edit": [
		2059,
		145
	],
	"./tariff_parent/edit": [
		2060,
		148
	],
	"./team/edit": [
		2061,
		151
	],
	"./text_message_source/edit": [
		2062,
		9
	],
	"./time_interval/edit": [
		2063,
		155
	],
	"./user/edit": [
		2064,
		158
	],
	"./voice_asterisk/edit": [
		2065,
		161
	],
	"./voice_asterisk_downgrade/edit": [
		2066,
		164
	],
	"./voice_recording_transcript_setting/edit": [
		2067,
		168
	],
	"./voice_route/edit": [
		2068,
		171
	],
	"./voice_shortcut/edit": [
		2069,
		174
	],
	"./voice_trunk/edit": [
		2070,
		177
	],
	"./voice_voicemail/edit": [
		2071,
		180
	],
	"./wallboard/edit": [
		2072,
		183
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1886;
module.exports = webpackAsyncContext;